import { MessageOutlined } from '@ant-design/icons';
import caregiversNoAi from 'assets/caregivers-no-ai.png';
import { Button } from 'components/ui';
import { colors, radius } from 'design';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    padding: 16,
    borderRadius: radius.md,
    backgroundColor: colors.surface.brandSubtle,
  },
  who: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  avatar: {
    height: 52,
    flexShrink: 0,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
    '& h4': {
      margin: 0,
      fontWeight: 500,
    },
    '& p': {
      margin: 0,
      fontSize: '0.9em',
      color: colors.text.secondary,
    },
  },
});

/**
 * Every category page and empty search ends on a human: a thin page leads to
 * a conversation with a midwife rather than a dead end.
 */
export default function AskMidwifeCard({ source }: { source: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.card} data-testid="ask-midwife-card">
      <div className={styles.who}>
        <img src={caregiversNoAi} alt="" className={styles.avatar} />
        <div className={styles.text}>
          <h4>{t('infoPage.structure.askMidwife.title')}</h4>
          <p>{t('infoPage.article.chatCallToAction.description')}</p>
        </div>
      </div>
      <Button
        variant="primary"
        block
        onClick={() => {
          posthog.capture('info.ask_midwife_clicked', { source });
          navigate(routes.messagingHome.route);
        }}
      >
        <MessageOutlined /> {t('infoPage.structure.askMidwife.button')}
      </Button>
    </div>
  );
}
